var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticStyle:{"background":"none"}},[_c('v-list-item-group',[_c('v-subheader',[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }